import { daysOfWeek } from "@sellar-io/common";
import { ReactElement, ReactNode, useState } from "react";
import { DeliveryAreaCreateContext } from "../contexts/DeliveryAreaCreateContext";

export const DeliveryAreaCreateProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const [postcodes, setPostcodes] = useState<string[]>([]);
  const [selectedDays, setSelectedDays] = useState<daysOfWeek[]>([]);

  return (
    <DeliveryAreaCreateContext.Provider
      value={{
        postcodes,
        setPostcodes,
        selectedDays,
        setSelectedDays,
      }}
    >
      {children}
    </DeliveryAreaCreateContext.Provider>
  );
};
